import React, { useEffect, useRef, useState } from "react";
import { Menu, Item, Megamenu, Row, Col, Buttonsave } from "./userMenuElements";
// import { ReactComponent as UserIcon } from "../../assets/icons/person.svg";
import { ReactComponent as NotificationsIcon } from "../../assets/icons/bell.svg";
import { ReactComponent as CreditCardIcon } from "../../assets/icons/credit-card.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout.svg";
import { ReactComponent as PaymentsIcon } from "../../assets/icons/money.svg";
import { ReactComponent as TrendingUpIcon } from "../../assets/icons/chart.svg";
import { ReactComponent as HistoryIcon } from "../../assets/icons/history.svg";
import { ReactComponent as PowerSettingsNewIcon } from "../../assets/icons/off.svg";
import { ReactComponent as GiftIcon } from "../../assets/icons/gift-solid.svg";
import avatar from "../../assets/images/avatar.png";
import UserIcon from "@mui/icons-material/AccountCircle";
import Beisball from "@mui/icons-material/Web";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import VeriUser from "@mui/icons-material/VerifiedUser";
import SaveImg from "@mui/icons-material/Save";
import { successNotification } from "../../utils/toastNotifications";
import { errorNotification } from "../../utils/toastNotifications";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDocumentoValidado,
  selectGameBalance,
  selectId,
  selectSaldoBonos,
  selectUser,
  selectWithdrawBalance,
  setActivePage,
  selectCurrency,
  selectToken,
  selectFoto,
  setNewToken,
  setUserBets,
  setImgPerfil,
} from "../../features/user/userSlice";
import { toLocale } from "../../utils/tools";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { selectHayNotificaciones } from "../../features/notifications/notificationsSlide";
import Star from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";
import {
  setShowUserBonos,
  setShowUserMenuMobile,
  setUrlverify,
  setShowJumio,
} from "../../features/modals/modalsSlice";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { API_URL, URL_PERFIL } from "../../const/api";
import SettingsIcon from "@mui/icons-material/Settings";

const MenuItems = ({ exit, isActiveImage }) => {
  const fileInputRef = useRef();
  const [t] = useTranslation("global");
  const id = useSelector(selectId);
  const saldo_juego = useSelector(selectGameBalance);
  const saldo_retiro = useSelector(selectWithdrawBalance);
  const saldo_bonos = useSelector(selectSaldoBonos);
  const [saldoTotal, setSaldoTotal] = useState("");
  const moneda = useSelector(selectCurrency);
  const token = useSelector(selectToken);
  const verificado = useSelector(selectDocumentoValidado);
  const hayNotificaciones = useSelector(selectHayNotificaciones);
  const usuario = useSelector(selectUser);
  const dispatch = useDispatch();
  const [preview, setPreview] = useState("");
  const changebtn = useMediaQuery("(min-width:750px)");
  const urlBaseball = `https://blog.masterbets365.com`;
  const [image, setImage] = useState(null);
  const [imageConfirm, setImageConfirm] = useState(false);
  const fotoPerfil = useSelector(selectFoto);
  const urlImage = "https://notificaciones.betsfactory.co/img_pp/";
  const [disableButton, setDisableButton] = useState(false);

  const [reloadImage, setReloadImage] = useState(false);

  const handleClick = (link) => {
    // window.scroll(0,0);
    setTimeout(() => {
      const scrollfooter = document.getElementById("root");
      scrollfooter.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 500);
    dispatch(setActivePage(link));
    dispatch(setShowUserMenuMobile(false));
  };
  const guardarImagen = async (e) => {
    e.preventDefault();
    if (image) {
      setDisableButton(true);
      let file = image;
      let body = { id: id, token: token };
      if (
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/Jpg" ||
        file.type === "image/Jpeg" ||
        file.type === "image/Png"
      ) {
        let iperfil = new FormData();
        iperfil.append("images", image);
        iperfil.append("tok", id);
        try {
          const uploadImg = await axios.post(URL_PERFIL, iperfil);
          const res = await axios.post(API_URL + "user", body);
          const responsePerfil = await axios.post(
            API_URL + "datosApuestaUser",
            {
              token: res.data.token,
              id_uo: id,
              moneda,
            }
          );
          dispatch(setNewToken(res.data.token));
          dispatch(setUserBets(responsePerfil.data.response));

          //esta mal la logica
          /* if (!responsePerfil.data.response.img_perfil == "") {
            const myphoto = responsePerfil.data.response.img_perfil;
            setPreview(urlImage + myphoto);
          } */

          if (responsePerfil.data.response.img_perfil !== "") {
            const myphoto = responsePerfil.data.response.img_perfil;
            setPreview(urlImage + myphoto);
            dispatch(setImgPerfil(myphoto));
          }
        } catch (error) {
          setReloadImage(true);
          console.log("error image", error);
        }
        setImageConfirm(false);
        successNotification(t("userProfile.exito"));
      } else {
        errorNotification(t("alert.errorNotificationRetiro-54"));
      }
      setDisableButton(false);
    }
  };

  useEffect(() => {
    const refreshData = async () => {
      setReloadImage(false);
      let body = { id: id, token: token };
      const res = await axios.post(API_URL + "user", body);
      const responsePerfil = await axios.post(API_URL + "datosApuestaUser", {
        token: res.data.token,
        id_uo: id,
        moneda,
      });

      dispatch(setNewToken(res.data.token));
      dispatch(setUserBets(responsePerfil.data.response));
    };
    if (reloadImage) refreshData();
  }, [reloadImage]);

  useEffect(() => {
    setSaldoTotal(
      (parseFloat(saldo_juego) + parseFloat(saldo_retiro)).toFixed(2)
    );
  }, [saldo_juego, saldo_retiro, saldo_bonos]);

  useEffect(() => {
    if (image) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(image);
      // activa el boton de guardado
      console.log("imagen subida", reader);
      setImageConfirm(true);
    } else {
      setPreview(null);
    }
  }, [image]);

  useEffect(() => {
    //console.log("actualizo imagen", fotoPerfil);
    setPreview(urlImage + fotoPerfil);
  }, [isActiveImage]);

  const verification = async (e) => {
    let body = {
      id_uo: id,
      token,
    };
    const res = await axios.post(API_URL + "verify", body);
    if (res.data.code === 200) {
      dispatch(setUrlverify(res.data.response_data.web.href));
      dispatch(setShowJumio(true));
    } else {
      if (res.data.message) {
        errorNotification(res.data.message, "top-center");
      } else {
        errorNotification(t("alert.errorNotificationRetiro-66"), "top-center");
      }
    }
  };

  return (
    <>
      <Menu className="d-none">
        <Item>
          <button>
            ID: {id}
            <span
              className={
                verificado === "0" ? "badget sinverificar" : "badget verificado"
              }
              title={
                verificado === "0"
                  ? "Usuario sin verificar"
                  : "Usuario verificado"
              }
            >
              {verificado === "0" ? "NO VERIFICADO" : "VERIFICADO"}
              {verificado === "0" ? <StarBorder /> : <Star />}
            </span>
          </button>
        </Item>
        <Item>
          <button>
            <CreditCardIcon />{" "}
            <span>
              {t(`user-menu.link-1.title`)} {toLocale(parseFloat(saldo_juego))}
            </span>
          </button>
        </Item>
        <Item>
          <button>
            <LogoutIcon />{" "}
            <span>
              {t(`user-menu.link-2.title`)} {toLocale(parseFloat(saldo_retiro))}
            </span>
          </button>
        </Item>
        <Item onClick={() => dispatch(setShowUserBonos(true))}>
          <button>
            <GiftIcon />{" "}
            <span>
              {t(`wallets.bonos`)}: {toLocale(parseFloat(saldo_bonos))}
            </span>
          </button>
        </Item>
        {(usuario === "test1" ||
          usuario === "test" ||
          usuario === "test2" ||
          usuario === "test3" ||
          usuario.toLowerCase() === "test4" ||
          usuario === "test5") && (
          <Item>
            <Link
              to={t(`user-menu.link-3.url`)}
              onClick={() => handleClick("user-menu.link-3.url")}
            >
              <PaymentsIcon /> <span>{t(`user-menu.link-3.title`)}</span>
            </Link>
          </Item>
        )}

        <Item>
          <Link
            to={t(`user-menu.link-4.url`)}
            onClick={() => handleClick("user-menu.link-4.url")}
          >
            <TrendingUpIcon /> <span>{t(`user-menu.link-4.title`)}</span>
          </Link>
        </Item>
        <Item>
          <Link
            to={t(`user-menu.link-5.url`)}
            onClick={() => handleClick("user-menu.link-5.url")}
          >
            <HistoryIcon /> <span>{t(`user-menu.link-5.title`)}</span>
          </Link>
        </Item>
        <Item>
          <Link
            to={t(`user-menu.link-6.url`)}
            onClick={() => handleClick("user-menu.link-6.url")}
          >
            <UserIcon /> <span>{t(`user-menu.link-6.title`)}</span>
          </Link>
        </Item>

        {!changebtn ? (
          <Item>
            <Link
              to={t(`user-menu.link-10.url`)}
              onClick={() => handleClick("user-menu.link-10.url")}
            >
              <VpnKeyIcon /> <span>{t(`user-menu.lbl-title`)}</span>
            </Link>
          </Item>
        ) : (
          ""
        )}
        {/* <Item>
          <Link>
            <VeriUser /> <span>{t(`userProfile.verificar`)}</span>
          </Link>
        </Item> */}
        <Item>
          <Link
            to={t(`user-menu.link-7.url`)}
            onClick={() => handleClick("user-menu.link-7.url")}
          >
            <NotificationsIcon />{" "}
            {hayNotificaciones && <span className="new"></span>}{" "}
            <span>{t(`user-menu.link-7.title`)}</span>
          </Link>
        </Item>
        <Item className="newribbon">
          <Link to={urlBaseball} target="_blank" rel="noreferrer">
            <Beisball />
            <span>{t("footer.gacetaBaseball")}</span>
          </Link>
        </Item>
        <Item className="danger" onClick={exit}>
          <button>
            <PowerSettingsNewIcon /> <span>{t(`user-menu.link-8.title`)}</span>
          </button>
        </Item>
      </Menu>
      <Megamenu>
        <Row>
          <Col className="pb-0">
            <div className="d-flex-col">
              <div className="myimage">
                {changebtn ? (
                  <>
                    <img
                      onClick={(e) => {
                        e.preventDefault();
                        fileInputRef.current.click();
                      }}
                      src={preview ? preview : avatar}
                      alt=""
                    />
                    {imageConfirm && (
                      <Buttonsave
                        disabled={disableButton}
                        onClick={guardarImagen}
                      >
                        <SaveImg />
                      </Buttonsave>
                    )}
                  </>
                ) : (
                  <>
                    <img
                      onClick={(e) => {
                        e.preventDefault();
                        fileInputRef.current.click();
                      }}
                      src={preview ? preview : avatar}
                      alt=""
                    />
                    {imageConfirm && (
                      <Buttonsave onClick={guardarImagen}>
                        <SaveImg />
                      </Buttonsave>
                    )}
                  </>
                )}
              </div>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file && file.type.substring(0, 5) === "image") {
                    setImage(file);
                  } else {
                    setImage(null);
                  }
                }}
              />
              <div>
                <p className="titleSaldo">
                  <span>ID:</span> {id}
                  <br></br>
                  {usuario}{" "}
                </p>
                <span className="saldouser saldototal">
                  {toLocale(parseFloat(saldoTotal))}
                </span>
                <span
                  className={
                    verificado === "0"
                      ? "badget sinverificar"
                      : "badget verificado"
                  }
                  title={
                    verificado === "0"
                      ? "Usuario sin verificar"
                      : "Usuario verificado"
                  }
                >
                  {verificado === "0" ? "NO VERIFICADO" : "VERIFICADO"}
                  {verificado === "0" ? <StarBorder /> : <Star />}
                </span>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="border-y">
          <Col className="pb-0">
            <p>{t(`user-menu.link-1.title`)}</p>
            <div className="d-flex-icons">
              <CreditCardIcon />
              <div>
                <span className="saldouser">
                  {toLocale(parseFloat(saldo_juego))}
                </span>
              </div>
            </div>
          </Col>
          <Col className="pb-0">
            <p>{t(`user-menu.link-2.title`)}</p>
            <div className="d-flex-icons">
              <LogoutIcon />
              <div>
                <span className="saldouser">
                  {toLocale(parseFloat(saldo_retiro))}
                </span>
              </div>
            </div>
          </Col>
          <Col className="pb-0">
            <p>{t(`wallets.bonos`)}:</p>
            <Link onClick={() => dispatch(setShowUserBonos(true))}>
              <div className="d-flex-icons">
                <GiftIcon className="animated infinite tada" />
                <div>
                  <span className="saldouser">
                    {toLocale(parseFloat(saldo_bonos))}
                  </span>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col className="border">
            <Link
              to={t(`user-menu.link-7.url`)}
              onClick={() => handleClick("user-menu.link-7.url")}
            >
              <NotificationsIcon
                className={hayNotificaciones ? "animated infinite swing" : ""}
              />{" "}
              {hayNotificaciones && <span className="new"></span>}{" "}
              <span>{t(`user-menu.link-7.title`)}</span>
            </Link>
          </Col>
          <Col className="border">
            <Link
              to={t(`user-menu.link-6.url`)}
              onClick={() => handleClick("user-menu.link-6.url")}
            >
              <UserIcon /> <span>{t(`user-menu.link-6.title`)}</span>
            </Link>
          </Col>
          <Col className="border">
            <Link
              to={t(`user-menu.link-10.url`)}
              onClick={() => handleClick("user-menu.link-10.url")}
            >
              <VpnKeyIcon /> <span>{t(`user-menu.lbl-title`)}</span>
            </Link>
          </Col>
        </Row>
        <Row className="border-y">
          <Col className="border">
            <Link
              to={t(`user-menu.link-4.url`)}
              onClick={() => handleClick("user-menu.link-4.url")}
            >
              <TrendingUpIcon /> <span>{t(`user-menu.link-4.title`)}</span>
            </Link>
          </Col>
          <Col className="border">
            <Link
              to={t(`user-menu.link-5.url`)}
              onClick={() => handleClick("user-menu.link-5.url")}
            >
              <HistoryIcon /> <span>{t(`user-menu.link-5.title`)}</span>
            </Link>
          </Col>
          <Col className="border">
            <Link to={`/settings`} onClick={() => handleClick("settings")}>
              <SettingsIcon /> <span>AJUSTES</span>
            </Link>
          </Col>
        </Row>
        {(usuario === "test1" ||
          usuario === "test" ||
          usuario === "test2" ||
          usuario === "test3" ||
          usuario.toLowerCase() === "test4" ||
          usuario === "test5" ||
          usuario.toLowerCase() === "doncorleonne" ||
          usuario.toLowerCase() === "aleromero" ||
          usuario.toLowerCase() === "jesusrojas" ||
          usuario.toLowerCase() === "r0mul0r") && (
            <Row>
              <Item>
                <Link
                  to={t(`user-menu.link-3.url`)}
                  onClick={() => handleClick("user-menu.link-3.url")}
                >
                  <PaymentsIcon /> <span>{t(`user-menu.link-3.title`)}</span>
                </Link>
              </Item>
            </Row>
        )}
        {verificado === "0" && (
          <Row>
            <Item>
              <Link
                onClick={() => {
                  verification();
                }}
              >
                <VeriUser /> <span>{t(`userProfile.verificar`)}</span>
              </Link>
            </Item>
          </Row>
        )}
        <Row>
          <Item>
            <Link to={urlBaseball} target="_blank" rel="noreferrer">
              <Beisball />
              <span>{t("footer.gacetaBaseball")}</span>
            </Link>
          </Item>
        </Row>
        <Row>
          <Col className="danger">
            <button onClick={exit}>
              <PowerSettingsNewIcon />{" "}
              <span>{t(`user-menu.link-8.title`)}</span>
            </button>
          </Col>
        </Row>
      </Megamenu>
    </>
  );
};

export default MenuItems;
